import { contentElem } from './globals';
import { retrieveFromSessionStorage} from './utilsStorage';

const IS_PRIVATE = retrieveFromSessionStorage('privatePages');

const fadeInClass = 'fade-in';

const removeFadeIn = (elem) => {
    elem = elem || contentElem;
    elem.classList.remove(fadeInClass)
}

const addFadeIn = (elem) => {
    elem = elem || contentElem;
    elem.classList.add(fadeInClass);
}

export {
    IS_PRIVATE,
    removeFadeIn,
    addFadeIn
}